import {
  Identifiable,
  Planzone,
  TimeRecordsListingConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getDefaultConf(): TimeRecordsListingConfiguration {
  return [
    {
      name: "All",
      roles: [
        "pz_admin",
        "pz_under_admin",
        "pz_user",
        "pz_visitor",
        "pr_visitor",
        "pr_manager",
        "pr_worker",
      ],
      columns: [
        { key: "date" },
        { key: "resourceTask" },
        { key: "project" },
        { key: "timeSpent" },
        { key: "validation" },
      ],
    },
  ];
}

function getTimeRecordsListingConfiguration(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ data }) =>
        !!data.timeRecordsListingViewConfigurations
          ? JSON.parse(data.timeRecordsListingViewConfigurations)
          : getDefaultConf(),
      );
}

export { getTimeRecordsListingConfiguration };
